// Development
import { API_PATHS } from './api-paths';
import { Environment } from './environment.model';

export const environment: Environment = {
  name: 'dev',
  production: false,
  apiUrl: 'https://dev.clientportal.thesnfist.com/api',
  version: '1.0.0',
  releaseDate: '07-21-2026',
  ...API_PATHS,
  session: {
    refreshBeforeExpiryMs: 15 * 60 * 1000,
    warningBeforeExpiryMs: 30 * 1000,
    idleTimeoutMs:         2 * 60 * 1000,
    idleCountdownSec:      30,
  },
};

